import { Dropdown } from 'src/components/FormComponents/Components/Dropdown';
import styledComponent from 'styled-components';

export const StyledDropdown = styledComponent(Dropdown as any)`
> div:nth-child(2) {
  height: 3.5rem;
}
> div:nth-child(3) div[tabIndex="-1"] {
  padding: 1rem 1rem;
}
`;